import {Link} from 'react-router-dom'
import {motion} from 'framer-motion'
import {NumericFormat} from "react-number-format";
import {ArrowCircleLeft} from '@mui/icons-material'


const EventCard = ({id, time, image, title,price}) => {


    // let content
    // if (statusCode === 0) {
    //     content = (
    //
    //         <button disabled className='button is-danger mx-auto clrsix pinar noborder wdith100 concertcardbutton '
    //                 >
    //             متاسفانه تمام شد.
    //         </button>
    //     )
    // } else if (statusCode === 2) {
    //     content = (<Counter timestamp={remain}/>)
    // } else {
    //     content = <Link to={`/schedule/${id}`}>
    //
    //         <button
    //
    //             className='button is-align-self-flex-end mx-auto clrone kook has-text-white noborder wdith100 concertcardbutton has-text-weight-bold '
    //             >
    //             خرید بلیط
    //         </button>
    //     </Link>
    // }


    return (
        <>

            <motion.div className='column productcardhover is-12-mobile is-6-tablet  is-3-desktop ' variants={{
                hidden: {scale: 0},
                visible: {scale: 1, opacity: 1}
            }}>
                <div
                    className='productcard p-1 borderrad1    mx-auto is-flex is-flex-direction-column is-flex-wrap-wrap is-justify-content-end  is-align-content-center      '
                    >

                    <img src={`${image}`} alt="produc"/>




                    <p className='kook wdith100 clrone  is-size-4 has-text-centered borderrad1 has-text-white  '  >
                        {title}


                        <span className='kook has-text-centered is-size-5 is-block py-2 borderrad1 clrtwotext' >
                      <i className="bi bi-calendar2-week ml-1 "></i>
                            <NumericFormat displayType='text' prefix={'$'} value={price}  thousandSeparator="," />

                  </span>



                    </p>



                    <Link className='has-text-left' to={`/products/${id}`}>

                        <button

                            className='button  clrone clrtwotext   clrone kook has-text-white noborder    has-text-weight-bold '
                        >


                           جزئیات  و بررسی
                            <ArrowCircleLeft className='mr-3' />
                        </button>
                    </Link>


                </div>


            </motion.div>


        </>
    )
}

export default EventCard;